"use client"

import { useState, useEffect } from "react";
import { Card, Form, Row } from "react-bootstrap";
import { showLoading } from "react-global-loading";
import { toast } from "react-toastify";

import * as myApi from "../Api";

const Profile = () => {

    const [user, setUser] = useState({});
    const [passwordErrors, setPasswordErrors] = useState({
        current_password: '',
        password: '',
        confirm_password: ''
    });

    useEffect(() => {
        // chekck if data is available
        const token = myApi.getToken();
        if (token) {
            setUser(myApi.getUser());
        }

    }, []);

    const handleChangePassword = (event) => {
        event.preventDefault();
        showLoading(true);
        const formData = new FormData(event.currentTarget);
        const data = {
            current_password: formData.get("current_password"),
            password: formData.get("password"),
            confirm_password: formData.get("confirm_password"),
        };

        // Validate passwords
        const errors = {};
        
        if (!data.current_password || data.current_password.trim() === '') {
            errors.current_password = 'Current password is required';
        }
        
        if (!data.password || data.password.trim() === '') {
            errors.password = 'New password is required';
        } else if (data.password.length < 6) {
            errors.password = 'Password must be at least 6 characters';
        }
        
        if (!data.confirm_password || data.confirm_password.trim() === '') {
            errors.confirm_password = 'Please confirm your password';
        } else if (data.password !== data.confirm_password) {
            errors.confirm_password = 'Passwords do not match';
        }

        if (Object.keys(errors).length > 0) {
            setPasswordErrors(errors);
            showLoading(false);
            toast("Please fix the validation errors", { type: "error" });
            return;
        }

        setPasswordErrors({});

        myApi.post("/change-password/", data)
            .then(() => {
                showLoading(false);
                toast("Password berhasil diubah", { type: "success" });
                // Clear the form
                event.currentTarget.reset();
            })
            .catch(() => {
                showLoading(false);
            });
    }

    return (
        <Row className="gap-5">     
            <Card className="bg-white">
                <Card.Header className="text-center bg-secondary text-white">User Profile</Card.Header>
                <Card.Body className="m-0 p-0" style={{ overflow: "auto", maxHeight: "400px" }}>
                    <div className="d-flex gap-3 mt-5 mb-5 justify-content-center">
                        <div>
                            <span><i className="material-symbols-outlined" style={{ fontSize: "100px" }}>person</i></span>
                        </div>
                        <div>
                            <h4 className="fw-semibold fs-20">
                                {user.name || "Unknown"} <span className="fw-light fs-14">({user.role || "Unknown"})</span>
                            </h4>
                            <p className="fs-14 p-0 m-0">
                                <span className="fw-semibold">Email:</span> {user.email || "Unknown"}
                            </p>
                            <p className="fs-14 p-0 m-0">
                                <span className="fw-semibold">Phone:</span> {user.phone || "Unknown"}
                            </p>
                            <p className="fs-14 p-0 m-0">
                                <span className="fw-semibold">Organization:</span> {user.organization || "Unknown"}
                            </p>
                        </div>
                    </div>
                </Card.Body>
            </Card>            
            <Card className="bg-white">
                <Card.Header className="text-center bg-secondary text-white">Reset Your Password</Card.Header>
                <Card.Body className="m-0 p-0">
                    <div className="d-flex mt-5 mb-5 justify-content-center">
                        <Form className="w-50" onSubmit={handleChangePassword}>
                            <Form.Group className="mb-3 text-center">
                                <Form.Label>Current Password</Form.Label>
                                <Form.Control 
                                    name="current_password" 
                                    type="password" 
                                    placeholder="*********" 
                                    className={passwordErrors.current_password ? 'is-invalid' : ''}
                                    required
                                />
                                {passwordErrors.current_password && (
                                    <Form.Control.Feedback type="invalid">
                                        {passwordErrors.current_password}
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                            <Form.Group className="mb-3 text-center">
                                <Form.Label>Password</Form.Label>
                                <Form.Control 
                                    name="password" 
                                    type="password" 
                                    placeholder="*********" 
                                    className={passwordErrors.password ? 'is-invalid' : ''}
                                    minLength={6}
                                    required
                                />
                                {passwordErrors.password && (
                                    <Form.Control.Feedback type="invalid">
                                        {passwordErrors.password}
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                            <Form.Group className="mb-3 text-center">
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control 
                                    name="confirm_password" 
                                    type="password" 
                                    placeholder="*********" 
                                    className={passwordErrors.confirm_password ? 'is-invalid' : ''}
                                    required
                                />
                                {passwordErrors.confirm_password && (
                                    <Form.Control.Feedback type="invalid">
                                        {passwordErrors.confirm_password}
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                            <Form.Group className="mb-3 text-center">
                                <button type="submit" className="btn btn-warning">Reset Password</button>
                            </Form.Group>
                        </Form>
                    </div>
                </Card.Body>
            </Card>
        </Row>    
    );
};

export default Profile;